import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import { useState } from "react";
import { useStore } from "../../../../../store";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SharedModal } from "../../../../../components/shared/SharedModal";
import env from "../../../../../config/env";

export const MyClassModal: React.FC<{
  classDetails: any;
  classType: string;
  isOpen: boolean;
  setIsSelectReviewModalOpen: (isOpen: boolean) => void;
  close: () => void;
}> = ({
  classDetails,
  classType,
  setIsSelectReviewModalOpen,
  close,
  isOpen,
}) => {
  const isOldSchedule = classDetails?.planning ? false : true;
  const navigate = useNavigate();

  const classStartDate = () => {
    if (isOldSchedule) {
      const userTimeZone = moment.tz.guess();
      const scheduleDates = classDetails.scheduleData.schedule.map(
        (date: string) => moment.utc(date).tz(userTimeZone)
      );
      return moment.min(scheduleDates).format("DD MMM YYYY").toUpperCase();
    }
    return "01 DEC 2024";
  };

  const classEndDate = () => {
    if (isOldSchedule) {
      const userTimeZone = moment.tz.guess();
      const scheduleDates = classDetails.scheduleData.schedule.map(
        (date: string) => moment.utc(date).tz(userTimeZone)
      );
      return moment.max(scheduleDates).format("DD MMM YYYY").toUpperCase();
    }
    return "01 DEC 2024";
  };

  const navigateToCourseDetails = () => {
    navigate(`/course/${classDetails.sessionCourse.id}`);
  };

  const openWriteReviewModal = () => {
    setIsSelectReviewModalOpen(true);
    close();
  };

  return (
    <SharedModal
      isOpen={isOpen}
      onRequestClose={close}
      width="950px"
      height="531px"
    >
      <div className="w-full flex flex-col justify-start items-start space-y-[25px] px-[16px] py-[16px] md:py-[33px] md:px-[32px]">
        {/* modal header */}
        <div className="w-full flex justify-between items-center">
          <span className="text-[#0A0003] font-inter font-extrabold text-[22px] leading-[32px] ">
            Class Details
          </span>
          {/* close modal button */}
          <button
            className="w-[34px] h-[34px] flex justify-center items-center rounded-full p-[8px] border border-[#DFDFDF]"
            onClick={close}
          >
            <svg
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.0687 13.432L9.00068 9.5M12.9327 5.56802L9.00068 9.5M9.00068 9.5L5.0687 5.56802M9.00068 9.5L12.9327 13.432"
                stroke="#0D0D0D"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
        {/* class image & name & view course button */}
        <div className="w-full flex flex-col md:flex-row justify-center md:justify-start items-center space-y-[12px] md:space-y-0 space-x-[0px] md:space-x-[26px]">
          {/* class image */}
          <div className="w-full h-[220px] md:w-[303px] md:h-[192px] overflow-hidden rounded-[16px] bg-gray-300 flex justify-center items-center">
            <img
              src={`${env.IMAGE_API}${
                classDetails.sessionImage
                  ? classDetails.sessionImage.name
                  : classDetails.SessionImage.name
              }`}
              alt={`${env.IMAGE_API}${
                classDetails.sessionImage
                  ? classDetails.sessionImage.name
                  : classDetails.SessionImage.name
              }`}
              className="w-full h-full object-cover"
            />
          </div>
          {/* class name & view course button */}
          <div className="w-full md:w-auto flex flex-col-reverse md:flex-col justify-start items-start gap-[16px] md:gap-0 md:space-y-[16px]">
            {/* class name */}
            <span className="text-[#0F0220] font-inter font-bold text-[22px] md:text-[32px] leading-[32px] md:leading-[38px] tracking-[-1px] line-clamp-2">
              {classDetails.title}
            </span>
            {/* view course button */}
            <div className="w-full flex justify-start items-center space-x-[10px]">
              <button
                type="button"
                className="w-1/2 h-[50px] md:w-[210px] md:h-[50px] rounded-[12px] border border-[#0A0003] px-[2px] md:px-[26px] md:py-[12px] text-[#0A0003] font-inter font-semibold text-[14px] leading-[26px] hover:bg-[#F5F5F5] hover:border-[2px] transition-all duration-300 "
                onClick={navigateToCourseDetails}
              >
                View Course Details
              </button>
              {/* write a review button */}
              {classType !== "upcoming" && (
                <button
                  type="button"
                  className="w-1/2 h-[50px] md:w-[190px] md:h-[50px] bg-[#E83C70] border border-[#E83C70] rounded-[12px] md:px-[24px] md:py-[12px] flex justify-center items-center space-x-[8px] hover:bg-white text-[#FFFAFB] hover:text-[#E83C70] transition-all duration-300 "
                  onClick={openWriteReviewModal}
                >
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.22361 5.49097L7.95529 2.00283C8.1776 1.55505 8.8198 1.55505 9.0421 2.00283L10.7738 5.49097L14.6463 6.05377C15.1432 6.12598 15.3413 6.73324 14.9815 7.0816L12.1799 9.79483L12.8411 13.6279C12.926 14.1202 12.4063 14.4955 11.9617 14.2631L8.4987 12.4523L5.03568 14.2631C4.5911 14.4955 4.07142 14.1202 4.15633 13.6279L4.81753 9.79483L2.01586 7.0816C1.65615 6.73324 1.85418 6.12598 2.35105 6.05377L6.22361 5.49097Z"
                      fill="#FFFAFB"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.44244 2.18167C8.42939 2.18936 8.41571 2.20162 8.40402 2.22517L6.67234 5.71331C6.59935 5.86033 6.45884 5.96217 6.2964 5.98578L2.42383 6.54857C2.33376 6.56166 2.30604 6.66573 2.36458 6.72243L5.16625 9.43566C5.285 9.55066 5.33923 9.71692 5.31113 9.87983L4.64993 13.7129C4.64553 13.7385 4.64936 13.7556 4.65496 13.7685C4.6614 13.7834 4.67333 13.7991 4.69109 13.8119C4.70884 13.8248 4.72824 13.8316 4.74582 13.8333C4.76137 13.8347 4.78054 13.8327 4.80487 13.82L8.26789 12.0092C8.41303 11.9333 8.58612 11.9333 8.73126 12.0092L12.1943 13.82C12.2186 13.8327 12.2378 13.8347 12.2533 13.8333C12.2709 13.8316 12.2903 13.8248 12.3081 13.8119C12.3258 13.7991 12.3378 13.7834 12.3442 13.7685C12.3498 13.7556 12.3536 13.7385 12.3492 13.7129L11.688 9.87983C11.6599 9.71692 11.7141 9.55066 11.8329 9.43566L14.6346 6.72243C14.6931 6.66573 14.6654 6.56166 14.5753 6.54857L10.7028 5.98578C10.5403 5.96217 10.3998 5.86033 10.3268 5.71331L8.59513 2.22517C8.58344 2.20162 8.56976 2.18936 8.55671 2.18167C8.54186 2.17292 8.52206 2.16699 8.49957 2.16699C8.47709 2.16699 8.45729 2.17292 8.44244 2.18167ZM7.50832 1.7805C7.91442 0.96249 9.08473 0.96249 9.49083 1.7805L11.106 5.03387L14.7191 5.55897C15.6228 5.6903 15.9911 6.80075 15.3302 7.44078L12.7184 9.97021L13.3347 13.5429C13.4911 14.4498 12.5366 15.1275 11.7309 14.7062L8.49957 13.0165L5.26824 14.7062C4.46252 15.1275 3.50806 14.4498 3.66449 13.5429L4.28077 9.97021L1.6689 7.44078C1.00801 6.80075 1.37635 5.6903 2.28001 5.55897L5.89319 5.03387L7.50832 1.7805Z"
                      fill="#FFFAFB"
                    />
                  </svg>
                  <span className=" font-inter font-semibold text-[14px] leading-[26px]  ">
                    Write a Review
                  </span>
                </button>
              )}
            </div>
          </div>
        </div>
        {/* class tutor name & classroom name & difficulty name & type into 4  using grid in a row */}
        <div className="hidden md:grid grid-cols-4  w-full gap-[26px]">
          {/* class tutor name */}
          <div className="flex flex-col justify-start items-start space-y-[2px]">
            <span className="text-[#1E1E1E] font-inter font-bold text-[16px] leading-[25px]">
              Tutor(s)
            </span>
            <span className="text-[#1F1F1F] font-inter font-normal text-[16px] leading-[25px]">
              {classDetails.title}
            </span>
          </div>
          {/* class classroom name */}
          <div className="flex flex-col justify-start items-start space-y-[2px]">
            <span className="text-[#1E1E1E] font-inter font-bold text-[16px] leading-[25px]">
              Classroom
            </span>
            <button
              type="button"
              className="text-[#E83C70] font-inter font-normal text-[16px] leading-[25px] underline underline-offset-2 decoration-[#E83C70]"
            >
              {classDetails.sessionBooking[0].bookingRoom.name}
            </button>
          </div>
          {/* class difficulty name */}
          <div className="flex flex-col justify-start items-start space-y-[2px]">
            <span className="text-[#1E1E1E] font-inter font-bold text-[16px] leading-[25px]">
              Level
            </span>
            <span
              className={`font-inter font-normal text-[16px] leading-[25px] ${
                classDetails.difficulty === "Beginner"
                  ? "text-[#9A1313]"
                  : classDetails.difficulty === "Intermediate"
                  ? "text-[#C5A227]"
                  : "text-[#138628]"
              }`}
            >
              {classDetails.difficulty}
            </span>
          </div>
          {/* class type name with the first letter uppercase */}
          <div className="flex flex-col justify-start items-start space-y-[2px]">
            <span className="text-[#1E1E1E] font-inter font-bold text-[16px] leading-[25px]">
              Type
            </span>
            <span className="text-[#1F1F1F] font-inter font-normal text-[16px] leading-[25px]">
              {classType.charAt(0).toUpperCase() + classType.slice(1)}
            </span>
          </div>
        </div>
        {/* class tutor name & classroom name & difficulty name & type for mobile screen in a column */}
        <div className="w-full flex md:hidden flex-col justify-start items-start space-y-[10px]">
          {/* class tutor name */}
          <div className="flex flex-col justify-start items-start space-y-[2px]">
            <span className="text-[#1E1E1E] font-inter font-bold text-[16px] leading-[25px]">
              Tutor(s)
            </span>
            <span className="text-[#1F1F1F] font-inter font-normal text-[16px] leading-[25px]">
              {classDetails.title}
            </span>
          </div>
          {/* class classroom name */}
          <div className="flex flex-col justify-start items-start space-y-[2px]">
            <span className="text-[#1E1E1E] font-inter font-bold text-[16px] leading-[25px]">
              Classroom
            </span>
            <button
              type="button"
              className="text-[#E83C70] font-inter font-normal text-[16px] leading-[25px] underline underline-offset-2 decoration-[#E83C70]"
            >
              {classDetails.sessionBooking[0].bookingRoom.name}
            </button>
          </div>
          <div className="w-full flex justify-start items-center">
            {/* class difficulty name */}
            <div className="w-1/2 flex flex-col justify-start items-start space-y-[2px]">
              <span className="text-[#1E1E1E] font-inter font-bold text-[16px] leading-[25px]">
                Level
              </span>
              <span
                className={`font-inter font-normal text-[16px] leading-[25px] ${
                  classDetails.difficulty === "Beginner"
                    ? "text-[#9A1313]"
                    : classDetails.difficulty === "Intermediate"
                    ? "text-[#C5A227]"
                    : "text-[#138628]"
                }`}
              >
                {classDetails.difficulty}
              </span>
            </div>
            {/* class type name with the first letter uppercase */}
            <div className="w-1/2 flex flex-col justify-start items-start space-y-[2px]">
              <span className="text-[#1E1E1E] font-inter font-bold text-[16px] leading-[25px]">
                Type
              </span>
              <span className="text-[#1F1F1F] font-inter font-normal text-[16px] leading-[25px]">
                {classType.charAt(0).toUpperCase() + classType.slice(1)}
              </span>
            </div>
          </div>
        </div>
        {/* class start date & end date */}
        <div className="w-full flex justify-start items-center space-x-[8px] md:space-x-[30px]">
          {/* class start date */}
          <div className="bg-[#F3EDFF] w-full h-[76px] md:w-[400px] md:h-[80px] rounded-[16px] border border-[#E2D3FF] md:px-[32px] py-[14px] flex justify-center items-center">
            <div className="w-full flex flex-col justify-center items-center space-y-[2px]">
              <span className="text-[#1E1E1E] font-inter font-bold text-[14px] md:text-[16px] leading-[25px]">
                Start Date
              </span>
              <span className="text-[#1F1F1F] font-inter font-normal text-[14px] md:text-[16px] leading-[25px]">
                {classStartDate()}
              </span>
            </div>
          </div>
          {/* arrow icon */}
          <svg
            viewBox="0 0 26 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-[24px] h-[24px] md:w-[26px] md:h-[27px] min-w-[24px] min-h-[24px]"
          >
            <path
              d="M4.33333 15.6663C3.13672 15.6663 2.16667 14.6963 2.16667 13.4997C2.16667 12.3031 3.13672 11.333 4.33333 11.333C5.52995 11.333 6.5 12.3031 6.5 13.4997C6.5 14.6963 5.52995 15.6663 4.33333 15.6663Z"
              stroke="#0F0220"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.7487 13.5H23.832M23.832 13.5L20.582 10.25M23.832 13.5L20.582 16.75"
              stroke="#0F0220"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          {/* class end date */}
          <div className="bg-[#F3EDFF] w-full h-[76px] md:w-[400px] md:h-[80px] rounded-[16px] border border-[#E2D3FF] md:px-[32px] py-[14px] flex justify-center items-center">
            <div className="w-full flex flex-col justify-center items-center space-y-[2px]">
              <span className="text-[#1E1E1E] font-inter font-bold text-[14px] md:text-[16px] leading-[25px]">
                End Date
              </span>
              <span className="text-[#1F1F1F] font-inter font-normal text-[14px] md:text-[16px] leading-[25px]">
                {classEndDate()}
              </span>
            </div>
          </div>
        </div>
      </div>
    </SharedModal>
  );
};

export const SelectReviewTypeModal: React.FC<{
  isOpen: boolean;
  close: () => void;
  setIsWriteReviewModalOpen: (isOpen: boolean) => void;
  setReviewType: (reviewType: string) => void;
}> = ({ close, isOpen, setIsWriteReviewModalOpen, setReviewType }) => {
  const handleReviewType = (reviewType: string) => {
    setReviewType(reviewType);
    setIsWriteReviewModalOpen(true);
    close();
  };

  return (
    <SharedModal
      isOpen={isOpen}
      onRequestClose={close}
      width="570px"
      height="480px"
      mobileWidth="378px"
      mobileHeight="448px"
    >
      <div className="w-full flex flex-col justify-start items-start md:pt-[18.5px] px-[10px] py-[10px] md:py-[33px] md:px-[32px]">
        {/* modal header */}
        <div className="w-full flex justify-between items-center pb-[14px] border-b border-[#F5F5F5] ">
          <span className="text-[#0A0003] font-inter font-bold text-[16px] leading-[25px] md:ml-[20px]">
            Write a Review
          </span>
          {/* close modal button */}
          <button
            className="w-[34px] h-[34px] flex justify-center items-center rounded-full p-[8px] border border-[#DFDFDF] md:mr-[20px]"
            onClick={close}
          >
            <svg
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.0687 13.432L9.00068 9.5M12.9327 5.56802L9.00068 9.5M9.00068 9.5L5.0687 5.56802M9.00068 9.5L12.9327 13.432"
                stroke="#0D0D0D"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
        {/* modal content */}
        <div className="w-full flex flex-col justify-start items-start space-y-[10px] md:space-y-[14px] mt-[20px] md:px-[20px] ">
          {/* modal content title */}
          <span className="text-[#2A2A2A] font-inter font-normal text-[16px] leading-[25px] ">
            Choose what you want to review
          </span>
          {/* modal content reviews types list */}
          <div className="w-full flex flex-col justify-start items-start space-y-[14px]">
            {/* review course button */}
            <button
              type="button"
              className="group w-full rounded-[12px] border border-[#DFDFDF] py-[20px] px-[30px] flex justify-between items-center hover:bg-[#FDFCFF] hover:border-[#8755E0] transition-all duration-300"
              onClick={() => handleReviewType("course")}
            >
              {/* review course icon & title & description */}
              <div className="flex justify-start items-center space-x-[20px]">
                {/* icon */}
                <svg
                  width="40"
                  height="41"
                  viewBox="0 0 40 41"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.08594 35.5C2.08594 34.8096 2.64558 34.25 3.33594 34.25L28.3359 34.25C29.0263 34.25 29.5859 34.8096 29.5859 35.5C29.5859 36.1904 29.0263 36.75 28.3359 36.75L3.33594 36.75C2.64558 36.75 2.08594 36.1904 2.08594 35.5Z"
                    fill="#8755E0"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M33.75 35.5C33.75 34.8096 34.3096 34.25 35 34.25L36.6667 34.25C37.357 34.25 37.9167 34.8096 37.9167 35.5C37.9167 36.1904 37.357 36.75 36.6667 36.75L35 36.75C34.3096 36.75 33.75 36.1904 33.75 35.5Z"
                    fill="#8755E0"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.58594 6.75V27.5833H35.4193V6.75H4.58594ZM2.08594 6.5C2.08594 5.25736 3.0933 4.25 4.33594 4.25H35.6693C36.9119 4.25 37.9193 5.25736 37.9193 6.5V27.8333C37.9193 29.076 36.9119 30.0833 35.6693 30.0833H4.33594C3.0933 30.0833 2.08594 29.076 2.08594 27.8333V6.5Z"
                    fill="#8755E0"
                  />
                </svg>
                {/* title & description */}
                <div className="flex flex-col justify-start items-start space-y-[2px]">
                  {/* title */}
                  <span className="text-[#0D0D0D] font-inter font-semibold text-[16px] md:text-[22px] leading-[25px] md:leading-[32px]">
                    Course
                  </span>
                  {/* description */}
                  <span className="text-[#0D0D0D] font-inter font-normal text-[14px] md:text-[16px] leading-[24px] md:leading-[25px] text-opacity-80 text-start md:text-center pr-[25px] md:pr-[0px]">
                    Rate your experience with the course
                  </span>
                </div>
              </div>
              {/* right arrow icon */}
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-[#1E1E1E] group-hover:stroke-[#8755E0] transition-all duration-300"
              >
                <path
                  d="M9 6.5L15 12.5L9 18.5"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            {/* review instructor button */}
            <button
              type="button"
              className="group w-full rounded-[12px] border border-[#DFDFDF] py-[20px] px-[30px] flex justify-between items-center hover:bg-[#FDFCFF] hover:border-[#8755E0] transition-all duration-300"
              onClick={() => handleReviewType("instructor")}
            >
              {/* review instructor icon & title & description */}
              <div className="flex justify-start items-center space-x-[20px]">
                {/* icon */}
                <svg
                  width="40"
                  height="41"
                  viewBox="0 0 40 41"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.0026 8.41699C17.0111 8.41699 14.5859 10.8421 14.5859 13.8337C14.5859 16.8252 17.0111 19.2503 20.0026 19.2503C22.9941 19.2503 25.4193 16.8252 25.4193 13.8337C25.4193 10.8421 22.9941 8.41699 20.0026 8.41699ZM12.0859 13.8337C12.0859 9.4614 15.6303 5.91699 20.0026 5.91699C24.3749 5.91699 27.9193 9.4614 27.9193 13.8337C27.9193 18.2059 24.3749 21.7503 20.0026 21.7503C15.6303 21.7503 12.0859 18.2059 12.0859 13.8337Z"
                    fill="#8755E0"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.0026 21.75C14.2496 21.75 9.58594 26.4137 9.58594 32.1667V33.8333C9.58594 34.5237 9.02629 35.0833 8.33594 35.0833C7.64558 35.0833 7.08594 34.5237 7.08594 33.8333V32.1667C7.08594 25.033 12.8689 19.25 20.0026 19.25C21.9814 19.25 23.8595 19.6958 25.539 20.4936C26.1625 20.7899 26.4279 21.5355 26.1317 22.1591C25.8355 22.7827 25.0898 23.048 24.4662 22.7518C23.1149 22.1098 21.6025 21.75 20.0026 21.75Z"
                    fill="#8755E0"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M29.9981 25.9647L28.8536 28.3915C28.6762 28.7677 28.3232 29.031 27.912 29.0939L25.2373 29.5031L27.2093 31.5133C27.4882 31.7976 27.6149 32.1978 27.5505 32.5908L27.0974 35.3557L29.3954 34.0909C29.7706 33.8843 30.2256 33.8843 30.6008 34.0909L32.8988 35.3557L32.4457 32.5908C32.3813 32.1978 32.508 31.7976 32.7869 31.5133L34.7589 29.5031L32.0842 29.0939C31.673 29.031 31.32 28.7677 31.1426 28.3915L29.9981 25.9647ZM28.3241 23.6533C28.9972 22.2262 30.999 22.2262 31.6721 23.6533L33.1199 26.7232L36.3348 27.215C37.9149 27.4568 38.392 29.3695 37.3733 30.4079L35.0153 32.8117L35.574 36.2213C35.8058 37.6357 34.3325 38.9985 32.8584 38.1871L29.9981 36.6128L27.1378 38.1871C25.6637 38.9985 24.1904 37.6357 24.4222 36.2213L24.9809 32.8117L22.6229 30.4079C21.6042 29.3695 22.0813 27.4568 23.6614 27.215L26.8763 26.7232L28.3241 23.6533Z"
                    fill="#8755E0"
                  />
                </svg>

                {/* title & description */}
                <div className="flex flex-col justify-start items-start space-y-[2px]">
                  {/* title */}
                  <span className="text-[#0D0D0D] font-inter font-semibold text-[16px] md:text-[22px] leading-[25px] md:leading-[32px]">
                    Instructor
                  </span>
                  {/* description */}
                  <span className="text-[#0D0D0D] font-inter font-normal text-[14px] md:text-[16px] leading-[24px] md:leading-[25px] text-opacity-80 text-start md:text-center">
                    Rate your experience with your instructor
                  </span>
                </div>
              </div>
              {/* right arrow icon */}
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-[#1E1E1E] group-hover:stroke-[#8755E0] transition-all duration-300"
              >
                <path
                  d="M9 6.5L15 12.5L9 18.5"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            {/* review classroom button */}
            <button
              type="button"
              className="group w-full rounded-[12px] border border-[#DFDFDF] py-[20px] px-[30px] flex justify-between items-center hover:bg-[#FDFCFF] hover:border-[#8755E0] transition-all duration-300"
              onClick={() => handleReviewType("classroom")}
            >
              {/* review classroom icon & title & description */}
              <div className="flex justify-start items-center space-x-[20px]">
                {/* icon */}
                <svg
                  width="40"
                  height="41"
                  viewBox="0 0 40 41"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M19.165 8.56466L5.29339 15.5005L19.165 22.4362L33.0366 15.5005L19.165 8.56466ZM18.1587 6.27269C18.7922 5.95598 19.5378 5.95598 20.1712 6.2727L34.6018 13.488C36.2602 14.3172 36.2602 16.6837 34.6018 17.5129L20.1712 24.7282C19.5378 25.0449 18.7922 25.0449 18.1588 24.7282L3.72815 17.5129C2.06979 16.6837 2.06978 14.3172 3.72814 13.488L18.1587 6.27269Z"
                    fill="#8755E0"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M33.0463 14.1073C33.355 13.4898 34.1059 13.2395 34.7234 13.5483L38.0567 15.2149C38.4802 15.4267 38.7477 15.8595 38.7477 16.333L38.7477 22.1663C38.7477 22.8566 38.188 23.4163 37.4977 23.4163C36.8073 23.4163 36.2477 22.8566 36.2477 22.1663L36.2477 17.1055L33.6053 15.7843C32.9878 15.4756 32.7376 14.7247 33.0463 14.1073Z"
                    fill="#8755E0"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 16.75C8.19036 16.75 8.75 17.3096 8.75 18V27.0202C8.75 27.8246 9.21312 28.5571 9.93979 28.9022L18.2731 32.8587C18.8386 33.1272 19.4948 33.1272 20.0602 32.8587L28.3935 28.9022C29.1202 28.5571 29.5833 27.8246 29.5833 27.0202V18C29.5833 17.3096 30.143 16.75 30.8333 16.75C31.5237 16.75 32.0833 17.3096 32.0833 18V27.0202C32.0833 28.7899 31.0645 30.4015 29.4658 31.1605L21.1325 35.1171C19.8885 35.7077 18.4449 35.7077 17.2009 35.1171L8.86753 31.1605C7.26885 30.4015 6.25 28.7899 6.25 27.0202L6.25 18C6.25 17.3096 6.80964 16.75 7.5 16.75Z"
                    fill="#8755E0"
                  />
                </svg>

                {/* title & description */}
                <div className="flex flex-col justify-start items-start space-y-[2px]">
                  {/* title */}
                  <span className="text-[#0D0D0D] font-inter font-semibold text-[16px] md:text-[22px] leading-[25px] md:leading-[32px]">
                    Classroom
                  </span>
                  {/* description */}
                  <span className="text-[#0D0D0D] font-inter font-normal text-[14px] md:text-[16px] leading-[24px] md:leading-[25px] text-opacity-80 text-start md:text-center">
                    Rate your experience with the classroom
                  </span>
                </div>
              </div>
              {/* right arrow icon */}
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-[#1E1E1E] group-hover:stroke-[#8755E0] transition-all duration-300"
              >
                <path
                  d="M9 6.5L15 12.5L9 18.5"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </SharedModal>
  );
};

export const WriteReviewModal: React.FC<{
  isOpen: boolean;
  close: () => void;
  reviewType: string;
  classDetails: any;
}> = ({ close, isOpen, reviewType, classDetails }) => {
  const { userStore } = useStore();

  const [rating, setRating] = useState<number>(0);
  const [reviewTitle, setReviewTitle] = useState<string>("");
  const [reviewContent, setReviewContent] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const submitReview = async () => {
    setIsSubmitting(true);
    let user = userStore.user;
    switch (reviewType) {
      case "course":
        let reviewData = {
          profileId: user.id,
          sessionId: classDetails.id,
          sStars: rating,
          feedbackSessionTitle: reviewTitle,
          feedbackSession: reviewContent,
        };
        await userStore
          .addReview(reviewData)
          .then((res) => {
            if (res) {
              setIsSubmitting(false);
              toast.success("Review submitted successfully");
              close();
            } else {
              setIsSubmitting(false);
              toast.error(
                "You have already submitted a review for this course"
              );
            }
          })
          .catch((err) => {
            setIsSubmitting(false);
          })
          .finally(() => {
            setIsSubmitting(false);
          });
        break;
      case "instructor":
        let instructorReviewData = {
          profileId: user.id,
          teacherId: classDetails.tutors.id,
          tStars: rating,
          feedbackTeacherTitle: reviewTitle,
          feedbackTeacher: reviewContent,
        };
        await userStore
          .addReview(instructorReviewData)
          .then((res) => {
            if (res) {
              setIsSubmitting(false);
              toast.success("Review submitted successfully");
              close();
            } else {
              setIsSubmitting(false);
              toast.error(
                "You have already submitted a review for this instructor"
              );
            }
          })
          .catch((err) => {
            console.log("error submitting review", err);
          })
          .finally(() => {
            setIsSubmitting(false);
          });
        break;
      case "classroom":
        let classroomReviewData = {
          profileId: user.id,
          roomId: classDetails.sessionBooking[0].bookingRoom.id,
          rStars: rating,
          feedbackRoomTitle: reviewTitle,
          feedbackRoom: reviewContent,
        };
        await userStore
          .addReview(classroomReviewData)
          .then((res) => {
            if (res) {
              setIsSubmitting(false);
              toast.success("Review submitted successfully");
              close();
            } else {
              setIsSubmitting(false);
              toast.error(
                "You have already submitted a review for this classroom"
              );
            }
          })
          .catch((err) => {
            console.log("error submitting review", err);
          })
          .finally(() => {
            setIsSubmitting(false);
          });
    }
  };

  return (
    <div>
      <SharedModal
        isOpen={isOpen}
        onRequestClose={close}
        width="570px"
        height="720px"
        mobileWidth="378px"
        mobileHeight="648px"
        mobilePx="10px"
        mobilePy="10px"
      >
        <div className="w-full flex flex-col justify-start items-start md:pt-[18.5px] ">
          {/* modal header */}
          <div className="w-full flex justify-between items-center pb-[14px] border-b border-[#F5F5F5]">
            <span className="text-[#0A0003] font-inter font-bold text-[16px] leading-[25px] md:ml-[20px]">
              Write a Review
            </span>
            {/* close modal button */}
            <button
              className="w-[34px] h-[34px] flex justify-center items-center rounded-full p-[8px] border border-[#DFDFDF] md:mr-[20px]"
              onClick={close}
            >
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.0687 13.432L9.00068 9.5M12.9327 5.56802L9.00068 9.5M9.00068 9.5L5.0687 5.56802M9.00068 9.5L12.9327 13.432"
                  stroke="#0D0D0D"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
          {/* modal content */}
          <div className="w-full flex flex-col justify-start items-start space-y-[20px] mt-[10px] md:mt-[20px] px-[0px] md:px-[20px]">
            {/* review type header & stars rating selection */}
            <div className="w-full flex flex-col justify-center items-center space-y-[10px]">
              {/* review type header */}
              <div className="w-full flex flex-col justify-center items-center space-y-[2px]">
                {reviewType === "course" && (
                  <span className="text-[#0D0D0D] font-inter font-semibold text-[22px] leading-[32px]">
                    Review Course
                  </span>
                )}
                {reviewType === "instructor" && (
                  <span className="text-[#0D0D0D] font-inter font-semibold text-[22px] leading-[32px]">
                    Review Instructor
                  </span>
                )}
                {reviewType === "classroom" && (
                  <span className="text-[#0D0D0D] font-inter font-semibold text-[22px] leading-[32px]">
                    Review Classroom
                  </span>
                )}
                {reviewType === "course" && (
                  <span className="text-[#1E1E1E] font-inter font-normal text-[14px] leading-[24px] text-opacity-80 ">
                    {classDetails.sessionCourse.title}
                  </span>
                )}
                {reviewType === "instructor" && (
                  <span className="text-[#1E1E1E] font-inter font-normal text-[14px] leading-[24px] text-opacity-80 ">
                    {classDetails.tutors.fullName}
                  </span>
                )}
                {reviewType === "classroom" && (
                  <span className="text-[#1E1E1E] font-inter font-normal text-[14px] leading-[24px] text-opacity-80 ">
                    {classDetails.sessionBooking[0].bookingRoom.name}
                  </span>
                )}
              </div>
              {/* stars rating selection */}
              <div className="flex flex-col items-center space-y-2">
                <div className="flex space-x-1">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <button
                      key={star}
                      onClick={() => setRating(star)}
                      className="focus:outline-none"
                    >
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill={rating >= star ? "#FFD700" : "none"}
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.4472 10.981L14.9106 4.00469C15.3552 3.10911 16.6396 3.10911 17.0842 4.00469L20.5476 10.981L28.2927 12.1066C29.2864 12.251 29.6825 13.4655 28.9631 14.1622L23.3597 19.5887L24.6821 27.2549C24.8519 28.2394 23.8126 28.9901 22.9234 28.5252L15.9974 24.9037L9.07136 28.5252C8.1822 28.9901 7.14285 28.2394 7.31267 27.2549L8.63507 19.5887L3.03173 14.1622C2.31229 13.4655 2.70836 12.251 3.70209 12.1066L11.4472 10.981Z"
                          stroke={rating >= star ? "#FFD700" : "#3F3F3E"}
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  ))}
                </div>
              </div>
            </div>
            {/* review title & content form */}
            <form className="w-full flex flex-col justify-start items-start space-y-[25px]">
              {/* review title */}
              <div className="w-full flex flex-col justify-start items-start space-y-[12px]">
                <label
                  htmlFor="reviewTitle"
                  className="text-[#1E1E1E] font-inter font-medium text-[12px] leading-[2px]"
                >
                  Title (Optional)
                </label>
                <input
                  type="text"
                  id="reviewTitle"
                  placeholder="Add a Title"
                  className="w-full rounded-[12px] border border-[#DFDFDF] py-[12px] px-[16px] focus:outline-none font-inter font-normal text-[14px] leading-[24px] placeholder:text-[#BCBCBC]"
                  value={reviewTitle}
                  onChange={(e) => setReviewTitle(e.target.value)}
                />
              </div>
              {/* review content */}
              <div className="w-full flex flex-col justify-start items-start space-y-[12px]">
                <label
                  htmlFor="reviewContent"
                  className="text-[#1E1E1E] font-inter font-medium text-[12px] leading-[2px]"
                >
                  Review (Optional)
                </label>
                <textarea
                  id="reviewContent"
                  placeholder="Describe your experience"
                  className="w-full rounded-[12px] border border-[#DFDFDF] py-[12px] px-[16px] focus:outline-none font-inter font-normal text-[14px] leading-[24px] resize-none h-[172px] placeholder:text-[#BCBCBC]"
                  value={reviewContent}
                  onChange={(e) => setReviewContent(e.target.value)}
                />
              </div>
              {/* review points for course review */}
              {reviewType === "course" && (
                <div className="w-full flex flex-col justify-start items-start border-b border-[#DFDFDF] pb-[20px] text-[#2A2A2A] font-inter font-medium text-[12px] leading-[24px] text-opacity-90">
                  <span>Points to mention:</span>
                  <ul className="list-disc">
                    <li>Did the course content meet your expectations?</li>
                    <li>
                      How would you describe the practical value of the course?
                    </li>
                    <li>Was the course well-organized and easy to follow?</li>
                  </ul>
                </div>
              )}
              {/* review points for instructor review */}
              {reviewType === "instructor" && (
                <div className="w-full flex flex-col justify-start items-start border-b border-[#DFDFDF] pb-[20px] text-[#2A2A2A] font-inter font-medium text-[12px] leading-[24px] text-opacity-90">
                  <span>Points to mention:</span>
                  <ul className="list-disc">
                    <li>
                      Was their teaching approach easy to follow and engaging?
                    </li>
                    <li>
                      Did they demonstrate strong knowledge of the subject?
                    </li>
                    <li>
                      How responsive and approachable were they during the
                      duration of the course?
                    </li>
                  </ul>
                </div>
              )}
              {/* review points for classroom review */}
              {reviewType === "classroom" && (
                <div className="w-full flex flex-col justify-start items-start border-b border-[#DFDFDF] pb-[20px] text-[#2A2A2A] font-inter font-medium text-[12px] leading-[24px] text-opacity-90">
                  <span>Points to mention:</span>
                  <ul className="list-disc">
                    <li>How comfortable was the learning environment?</li>
                    <li>Was the classroom easy to locate and reach?</li>
                  </ul>
                </div>
              )}
              {/* form cancel & submit buttons */}
              <div className="w-full flex justify-center md:justify-end items-center md:items-end space-x-[6px] md:space-x-[12px]">
                <button
                  type="button"
                  className="w-1/2 md:w-[102px] h-[50px] md:px-[34px] md:py-[12px] rounded-[12px] border border-[#DFDFDF] font-inter font-semibold text-[14px] leading-[26px]"
                  onClick={close}
                >
                  Back
                </button>
                <button
                  type="button"
                  className="w-1/2 md:w-[169px] h-[50px] md:px-[34px] md:py-[12px] rounded-[12px] bg-black text-white font-inter font-semibold text-[14px] leading-[26px]"
                  onClick={submitReview}
                >
                  {isSubmitting ? (
                    <div className="flex justify-center items-center">
                      <div className="w-4 h-4 border-t-2 border-b-2 border-white rounded-full animate-spin"></div>
                    </div>
                  ) : (
                    "Submit Review"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </SharedModal>
    </div>
  );
};
